<template>
    <div class="artic">
        <div class="banner1"><img src="../assets/images/banner.png"></div>
        <div class="content">
            <div class="artical">
                <h2>{{artTitle}}</h2>
                <h3>发布日期：{{publishDate}}
                    <!-- <span>点击量  {{clickNum}}</span> -->
                    </h3>           
                <div style="line-height: 28px;font-size: 16px;" v-html="bodyInfo"></div>
            </div>
            <!-- <div class="reco">
                <div class="read">
                    <p>相关阅读</p>
                    <ul>
                        <li></li>
                    </ul>
                </div>
                <div class="vid">
                    <p>推荐视频</p>
                    <ul>
                        <li></li>
                    </ul>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import api from '../assets/config/api'
export default {
    // 根据路由id获取文章
    data() {
        return {
            artical:''
        }
    },
    computed: {
        artTitle:function () {
            return this.artical.ArtTitle
        },
        clickNum:function () {
            return this.artical.ClickNum
        },
        bodyInfo:function () {
            //修改文章中所有图片的链接
            if(this.artical.BodyInfo){
                var str = this.artical.BodyInfo.replace(/21.254.198.14:9011/g,"lishui.yeshiweb.com:8081/").replace(/请输入图片描述/g,'');
                return str
                //return this.artical.BodyInfo
            }
        },
        publishDate:function () {
            return this.artical.PublishDate
        }
    },
    async mounted() {
        var colid = this.$route.query.colid
        await axios.post(api.artInfo, {
            col_id:142,art_id:colid
        })
        .then(response => {
            // console.log(response);
            this.artical = response.data.InfoDetail
        })
        .catch(function (error) {
            console.log(error);
        });
    },
}
</script>

<style lang="less" scoped>
    .artic{
        padding-bottom: 80px;
        .banner1{
            position: relative;
            width: 100%;
            img{
                width: 100%;
            }
        }
        .content{
            width: 1200px;
            margin: 0 auto;
            overflow: hidden;
            .artical{
                h2{
                    text-align: center;
                    line-height: 50px;
                    font-weight: normal;
                    font-size: 28px;
                }
                h3{
                    width: 260px;
                    line-height: 50px;
                    font-weight: normal;
                    color: #999;
                    font-size: 14px;
                    margin: 0 auto;
                    span{
                        float: right;
                    }
                }
            }
            .reco{
                width: 300px;
                float: right;
                .read{
                    p{
                        height: 54px;
                        line-height: 54px;
                        background: #f7dab8;
                        text-align: center;
                        color: #a24b38;
                    }
                }
                .vid{
                    p{
                        height: 54px;
                        line-height: 54px;
                        background: #f7dab8;
                        text-align: center;
                        color: #a24b38;
                    }
                }
            }
        }
    }
</style>